import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const ProfileSettingsPage = withSuspense(
	lazy(async () => await import('./profile-settings-page.component')),
	PageLoader,
);
